<template>
  <div v-loading="loading" class="page-form">
    <h3 class="title">发货计划导入</h3>

    <div class="form-container">
      <errors-list :errors="errorList" />
      <div class="tools">
        <btky-header
          :form-data="conditions"
          :process-key="processKey"
          @validate="validate"
          @formDataSave="saveData"
        />
      </div>
      <el-form
        ref="form"
        inline
        size="mini"
        label-width="100px"
        :disabled="isEdit"
        :model="conditions"
        :show-message="false"
        :rules="rules"
      >
        <el-row :gutter="24">
          <el-col :lg="8" :md="12">
            <el-form-item prop="billCode" label="月度计划编号">
              <el-input
                v-model="conditions.billCode"
                disabled
                placeholder="自动生成"
                type="text"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item prop="billType" label="创建人">
              <el-input
                v-model="conditions.createdByName"
                disabled
                placeholder="请输入"
                type="text"
              />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item prop="createdDate" label="创建时间">
              <el-input v-model="conditions.createdDate" disabled placeholder="请输入" />
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item prop="yxdy" label="营销单元" class="box">
              <el-select
                v-model="conditions.yxdy"
                placeholder="请选择"
                clearable
                suffix-icon="el-icon-more"
                @change="onChangeYxdy"
              >
                <el-option
                  v-for="item in saleList"
                  :key="item.SOBID"
                  :value="item.SOBID"
                  :label="item.MC_SHORT"
                />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :lg="8" :md="12">
            <el-form-item prop="pyear" label="计划年度">
              <el-date-picker
                v-model="conditions.pyear"
                type="year"
                value-format="yyyy"
                format="yyyy"
                clearable
              />
            </el-form-item>
          </el-col>
          <el-col :lg="12" :md="12">
            <el-form-item label="备注">
              <el-input
                v-model="conditions.remark"
                placeholder="请输入"
                type="textarea"
                clearable
                rows="2"
              />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>

    <div class="table-container">
      <TableCommon title="明细信息" :custome-config="() => vxeShowCustom('xTable')">
        <template #button>
          <table-button name="download" tip="模版下载" @click="downloadTemplate" />
          <table-button name="import" tip="导入" @click="tableEvent('import')" />
          <table-button name="delete" tip="删除" @click="removeData" />
        </template>
        <vxe-grid
          ref="xTable"
          class="table-block"
          border
          :highlight-hover-row="true"
          resizable
          :show-overflow="true"
          height="300"
          align="center"
          size="mini"
          :checkbox-config="{ highlight: true }"
          :radio-config="{ highlight: true }"
          :empty-render="{ name: 'NotData' }"
          :edit-rules="validRules"
          :toolbar-config="{ custom: true, size: 'mini' }"
          :row-config="{ isCurrent: true }"
          :columns="gridOptions.columns"
          :data="gridOptions.data"
        >
          <template #zqdlx="{ row }">
            <div>
              <el-select
                v-model="row['zqdlx']"
                disabled
              >
                <el-option
                  v-for="selectItem in selectDataOptions['goodsPlanType']"
                  :key="selectItem.value"
                  :value="selectItem.value"
                  :label="selectItem.name"
                />
              </el-select>
            </div>
          </template>
        </vxe-grid>
      </TableCommon>
      <btky-footer :form-data="conditions" />
    </div>
  </div>
</template>

<script>
import { apiLoadDictionaryDtl } from '@/api/platform/dictionary/index'
import { apiMonthplanFindById } from '@/api/applyForGoods/monthly'
import { apiGetOrgOrBase } from '@/api/sap/common-sap'
import { handlerFlow } from '@/api/flowHander'
import { DOWNLOAD_API } from '@/api/baseUrl'
import { getToken } from '@/utils/auth'
import { apiSapClientFindInfo, apiExcelImport, apiExportExcelTemplate, apiGetExcelImportData } from '@/api/common'
import { mapGetters } from 'vuex'

const rules = {
  yxdy: [{ required: true, message: '请选择营销单元', trigger: 'change' }],
  pyear: [{ required: true, message: '请选择年度', trigger: 'blur' }]
}

export default {
  data() {
    return {
      rules,
      loading: false,
      processKey: 'ztcrmTgpplanM1Import',
      dialogTitle: '',
      showDialog: false,
      validRules: {},
      importConfig: {
        templateCode: 'monthPlanImport',
        batchNumber: ''
      },
      conditions: {
        id: '',
        bizId: '',
        taskId: '',
        zyear: '',
        p: '',
        remark: '',
        yxdy: '',
        yxdyName: '',
        businessType: 'import',
        status: 0,
        billCode: '',
        createdDate: '',
        createdByName: '',
        ztcrmTgpplanM1List: []
      },
      selectDataOptions: {},
      errorList: [],
      saleList: [],
      currentRow: null,
      gridOptions: {
        columns: [
          { type: 'checkbox', field: 'checkbox', title: '', width: 50 },
          { field: 'partner', title: '客户编码', width: 100 },
          { field: 'name', title: '客户名称', width: 120 },
          { field: 'brand', title: '存货分类', width: 80 },
          { field: 'brandName', title: '存货分类描述', width: 120 },
          { field: 'zqdlx', title: '渠道类型', width: 120, slots: { default: 'zqdlx' }},
          { field: 'qdjhl', title: '渠道计划量', width: 120 },
          // { field: 'amtAllqdInit', title: '全年渠道初始计划量', width: 140 },
          // { field: 'amtAllInit', title: '全年初始计划量', width: 110 },
          // { field: 'amountAll', title: '全年计划量', width: 80 },
          { field: 'zyxdy', title: '营销单元', width: 120 },
          { field: 'zyxdyName', title: '营销单元名称', width: 120 },
          { field: 'm12Plan', title: '12月计划量', width: 110 },
          { field: 'm1Plan', title: '1月计划量', width: 100 },
          { field: 'm2Plan', title: '2月计划量', width: 100 },
          { field: 'm3Plan', title: '3月计划量', width: 100 },
          { field: 'm4Plan', title: '4月计划量', width: 100 },
          { field: 'm5Plan', title: '5月计划量', width: 100 },
          { field: 'm6Plan', title: '6月计划量', width: 100 },
          { field: 'm7Plan', title: '7月计划量', width: 100 },
          { field: 'm8Plan', title: '8月计划量', width: 100 },
          { field: 'm9Plan', title: '9月计划量', width: 100 },
          { field: 'm10Plan', title: '10月计划量', width: 110 },
          { field: 'm11Plan', title: '11月计划量', width: 110 },
          { field: 'initPlanNum', title: '待分解量', width: 120 }
        ],
        data: []
      }
    }
  },
  computed: {
    ...mapGetters(['userInfo']),
    isEdit() {
      return false
    }
  },
  watch: {
    'gridOptions.data': {
      handler(newVal) {
        this.conditions.ztcrmTgpplanM1List = newVal
      },
      deep: true
    }
  },
  created() {
    this.getSelectDictDataOrigin('A0009')
    this.getSelectDictDataOrigin('A0054')
    this.getSelectDictDataOrigin('goodsPlanType')
    this.initCustome()
    apiGetOrgOrBase().then(res => {
      this.saleList = res.DATA
    })
    const { id, taskId } = this.$route.query
    if (id) {
      this.conditions.id = id
      this.conditions.bizId = id
      taskId && (this.conditions.taskId = taskId)
      this.initDetail()
    } else {
      this.conditions.createdByName = this.userInfo.name
      this.conditions.createdDate = this.$utilsCommon.parseTime(new Date().getTime(), '{y}-{m}-{d}')
    }
  },
  methods: {
    // 查询客户信息
    async initCustome() {
      const params = { rt_partner: [{
        SIGN: 'I',
        OPTION: 'EQ',
        LOW: '0050000215',
        HIGH: ''
      }], page: 1, pagesize: 50 }
      // 当前登录账号和角色
      params.partner = this.$store.getters.role.USER_BP
      params.role = this.$store.getters.role.ROLE
      const { data } = await apiSapClientFindInfo(params)
      this.$set(this.selectDataOptions, 'orgList', data[0]?.yxdy || [])
    },
    initDetail() {
      apiMonthplanFindById(this.conditions).then(res => {
        res.data.pyear += ''
        this.conditions = { ...this.conditions, ...res.data }
        this.gridOptions.data = res.data.ztcrmTgpplanM1List || []
        console.log(res)
      })
    },
    saveData() {
      const params = JSON.parse(JSON.stringify(this.conditions))
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.loading = true
          handlerFlow(params, this.processKey)
            .then(response => {
              this.loading = false
              console.log(response)
              if (!this.conditions.id) {
                this.conditions.id = response.data.bizId
                Object.assign(this.conditions, response.data.bizData)
                this.conditions.bizId = response.data.bizId
                this.conditions.taskId = response.data.taskId
                this.conditions.billCode = response.data.bizData.billCode
              }
              this.gridOptions.data = response.data.bizData.ztcrmTgpplanM1List
              this.$message.success('保存成功')
            })
            .catch(() => {
              this.loading = false
            })
        }
      })
    },
    tableEvent(btn) {
      switch (btn) {
        case 'import':
          this.handleImportExcel()
          break
      }
    },
    validate(cb) {
      this.errorList = []
      this.$refs['form'].validate((valid, err) => {
        if (valid) {
          if (!this.gridOptions.data.every(v => v.zyxdy === this.conditions.yxdy)) {
            this.errorList = ['选择的营销单元与导入的营销单元不一致！']
            return
          }
          cb()
        } else {
          this.errorList = this.$utilsCommon.filterErrorMsg(err)
          return false
        }
      })
    },
    async removeData() {
      const checkedList = this.$refs.xTable.getCheckboxRecords()
      checkedList.forEach(item => {
        const index = this.gridOptions.data.findIndex(v => v._X_ID === item._X_ID)
        this.gridOptions.data.splice(index, 1)
      })
    },
    updateTotal(item) {
      item.qdjhl = Number(item.m1Plan) + Number(item.m2Plan) + Number(item.m3Plan) + Number(item.m4Plan) + Number(item.m5Plan) + Number(item.m6Plan) + Number(item.m7Plan) + Number(item.m8Plan) + Number(item.m9Plan) + Number(item.m10Plan) + Number(item.m11Plan) + Number(item.m12Plan)
    },
    getSelectDictDataOrigin(dictcode) {
      const formData = new FormData()
      formData.append('code', dictcode)
      apiLoadDictionaryDtl(formData)
        .then(response => {
          this.$set(this['selectDataOptions'], dictcode, response.data.Rows)
        })
        .catch(() => {})
    },
    // 导入excel
    async handleImportExcel() {
      this.$refs.xTable
        .readFile({
          types: ['xlsx']
        })
        .then(async resp => {
          const { files } = resp
          const formData = new FormData()
          Array.from(files).forEach(file => {
            formData.append('file', file)
          })
          const params = {
            formData,
            templateCode: this.importConfig.templateCode
          }
          const res = await apiExcelImport(params)
          if (res?.status === 1) {
            this.importConfig.batchNumber = res.data
            this.handleQueryImportExcel(res.data)
          }
        })
    },
    // 查询导入excel数据
    async handleQueryImportExcel() {
      const { page, pagesize } = this.importConfig
      const params = { ...this.importConfig, page, pagesize }
      const res = await apiGetExcelImportData(params)
      console.log(res.data.Rows)
      this.gridOptions.data = res.data.Rows
      this.gridOptions.data.map(item => {
        this.updateTotal(item)
      })
    },
    // 营销单元选择事件
    onChangeYxdy(data) {
      const org = this.selectDataOptions['orgList'].find(v => {
        v.zzfld00001h === data
      })
      console.log(org)
      if (data) {
        this.conditions.yxdyName = org.mc_short
      } else {
        this.conditions.yxdyName = ''
      }
    },
    // 模板下载
    async downloadTemplate(filename = '发货计划导入模板') {
      const res = await apiExportExcelTemplate(this.importConfig.templateCode)
      if (res?.status !== 0) {
        return
      }
      const url = `${DOWNLOAD_API()}/attachment/downFileByTmpdir.ajax?file=${
        res.data.file
      }&authToken=${getToken()}&fileName=${filename}`
      const link = document.createElement('a')
      link.style.display = 'none'
      link.href = url
      link.target = '_blank'
      link.setAttribute('download', filename)
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      URL.revokeObjectURL(url)
    }
  }
}
</script>

<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/views/apply-for-manage/base-setting/deliveryPlanImport.vue